export const data = function() {
  return {
    isDebug: true,
    loading: false,
    escrowID: 0,
    tabs: [
      { name: 'escrowDetails', label: 'Details' },
      { name: 'escrowConversations', label: 'Conversations' }
    ],
    styles: {
      mainContainer: {
        minHeight: '1000px'
      }
    },
    transitionName: 'slide-down',
    showUploadModal: false
  }
}
